import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

import { IPeriod } from 'src/app/_models/period.vm';
import { trackByPeriodId } from '../../utils/track-by';

@Component({
    selector: 'app-period-dropdown',
    templateUrl: './period-dropdown.component.html',
    styleUrls: ['./period-dropdown.component.scss'],
    standalone: false
})
export class PeriodDropdownComponent implements OnInit {
  public readonly trackByPeriodId = trackByPeriodId;


  @Input() public periods: Array<IPeriod>;
  @Input() public selectedPeriod: IPeriod;
  @Input() public helperText: string;
  @Input() public loading: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public busy: boolean = false;
  /**
   * Renders the list on the page rather than behind a trigger. Used by the mobile
   * sheet, where a dropdown inside a panel would be a menu within a menu.
   */
  @Input() public inline: boolean = false;

  @Output() public opened = new EventEmitter<void>();
  @Output() public periodSelected = new EventEmitter<IPeriod>();

  @ViewChild(NgbDropdown) private dropdown: NgbDropdown;

  public isOpen: boolean = false;

  public ngOnInit(): void {
    // There is no trigger to open when inline, so the list is being shown from the
    // moment it is created and the periods are needed straight away. Left to the
    // next turn because the parent loads them in response, which would change inputs
    // that have already been checked in this pass.
    if (this.inline) {
      setTimeout(() => this.opened.emit());
    }
  }

  public onOpenChange(open: boolean): void {
    this.isOpen = open;
    if (open) {
      this.opened.emit();
    }
  }

  public selectPeriod(period: IPeriod): void {
    if (this.dropdown) {
      this.dropdown.close();
    }
    if (period.TimePeriodID == this.selectedPeriod?.TimePeriodID) {
      return;
    }
    this.periodSelected.emit(period);
  }

  public isSelected(period: IPeriod): boolean {
    return period.TimePeriodID == this.selectedPeriod?.TimePeriodID;
  }
}
